import React from 'react'
import { Archive, Handshake, LoaderCircle } from 'lucide-react'
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import DeactivateButton from '../buttons/deactivate'
import HandoverButton from '../buttons/handover'

class CloseEnquiry extends React.Component {

  render() {
    if (this.props.ui.handing_over_enquiry || this.props.ui.deactivating_enquiry) {
      return (
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Handshake className="size-4" />
              Close Enquiry
            </CardTitle>
          </CardHeader>
          <CardContent className="text-center">
            <LoaderCircle className="inline size-8 animate-spin"/>
          </CardContent>
        </Card>
      )
    }

    const showDeactivate = this.props.enquiry.actions.can_deactivate && !this.props.ui.enquiry.buttons.support_handover.open
    const showHandover = this.props.enquiry.actions.can_handover && !(this.props.ui.enquiry.buttons.deactivate.open || this.props.ui.enquiry.buttons.reactivate.open)

    return (
      <React.Fragment>
        {showDeactivate ?
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Archive className="size-4" />
                Deactivate
              </CardTitle>
            </CardHeader>
            <CardContent>
              <DeactivateButton
                enquiry_id={this.props.enquiry.id}
                ui={this.props.ui.enquiry.buttons.deactivate}
              />
            </CardContent>
          </Card>
          : null
        }
        {showHandover ?
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Handshake className="size-4" />
                Hand Over
              </CardTitle>
            </CardHeader>
            <CardContent>
              <HandoverButton
                enquiry_id={this.props.enquiry.id}
                enquiry_manager_id={this.props.enquiry.manager.id}
                claim_managers={this.props.enquiry.claim_managers}
                ui={this.props.ui.enquiry.buttons.support_handover}
              />
            </CardContent>
          </Card>
          : null
        }
      </React.Fragment>
    )
  }
}

export default CloseEnquiry
